export default "__VITE_ASSET__BfSYP8fR__"